export default "__VITE_ASSET__D8_tBISS__"